export const MUTATION_KEYS = {
    save_host: 'save-host',
    unsave_host: 'unsave_host',
    renewSubscriptionV3: 'renewSubscriptionV3'
}

export const QUERY_KEYS = {
    subscriptionsToRenewV3: 'subscriptionsToRenewV3',
    subscriptionsToRenewCreditCardV3: 'subscriptionsToRenewCreditCardV3',
    saved_hosts: 'saved_hosts',
    ages: 'ages',
    host_profile: 'host-profile'
}
